import { HttpClient } from '@/shared/lib/http-client';

export const fetchPageSeo = async(page) => {
  const response = await HttpClient.get('/page-seo', { page });

  return response.data?.data;
};
